export const CARETEAM_LIST = "CARETEAM_LIST";

export const setCareteamList = (payload) => {
   return {
      type: CARETEAM_LIST,
      payload,
   };
};
